const YOUTUBE_ID_PATTERN = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([A-Za-z0-9_-]{6,})/;

export function initCardsYoutube(query = document.querySelectorAll('.js-cardsYoutube')) {
    for (const el of query) {
        if (el.dataset.cardsYoutubeInit) {
            continue;
        }
        el.dataset.cardsYoutubeInit = "true";

        const match = (el.getAttribute('src') || '').match(YOUTUBE_ID_PATTERN);
        if (match) {
            el.setAttribute('src', `https://www.youtube.com/embed/${match[1]}`);
        }
    }
}
